<template>
    <el-dialog @close='closeDialog' title="提示" :visible.sync="dialogVisible">
        <div class="no_class_pop">
            <img :src="require('@/common/images/other/icon_tip.png')" alt="">
            <p>暂无分类，请前往分类管理中新建分类</p>
        </div>
        <div slot="footer" class="dialog-footer">
            <el-button @click="dialogVisible = false">取 消</el-button>
            <el-button type="primary" @click="sureBtn()">立即创建</el-button>
        </div>
    </el-dialog>
</template>

<script>
import {mapGetters, mapActions} from 'vuex'
import $ from 'jquery'
export default {
    name: 'NoClassPop',
    data() {
        return {
            dialogVisible: false
        }
    },
    mounted() {},
    methods: {
        // 打开弹窗
        openDialog(val) {
            // console.log(val)
            this.dialogVisible = true
        },
        // 关闭弹框
        closeDialog() {
            this.dialogVisible = false
        },
        // 确定按钮
        sureBtn() {
            this.$router.push({name: 'QuestionbankType'})
        },
        ...mapActions([
            'setLoading'
        ])
    },
    filters: {},
    watch: {},
    computed: {
        ...mapGetters([
            'user'
        ])
    },
    components: {}
}
</script>

<style lang="scss" type="text/scss" rel="stylesheet/scss">
    .no_class_pop {
        display: flex;
        flex-direction: column;
        align-items: center;
        padding: 20px 0;
        &>img{
            width: 60px;
            height: 60px;
            margin-bottom: 20px;
        }
        &>p{
            font-size:14px;
            color:rgba(48,49,51,1);
            line-height:20px;
        }
    }
</style>
